<template>
  <div class="notfound">
    <h2>Page Not Found</h2>
    <p>404</p>
  </div>
</template>

<style>
  .notfound {
    max-width: 400px;
    background: #ff9ed2;
    color: white;
    margin: 40px auto;
    padding: 20px;
    border-radius: 15px;
  }
</style>
